import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccidentRecordService {
  constructor(private http: HttpClient) {}

  createAccidentRecord(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/accident/create`, payload);
  }

  updateAccidentRecord(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/accident/update`, payload);
  }

  softDeleteAccidentRecord(id: any): Observable<any> {
    return this.http.delete(`${SETTINGS.BASE_API}/accident/soft-delete/${id}`);
  }

  getAccidentRecordWithDetailsById(id: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/accident/${id}`);
  }

  getPagedAccidentRecord(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/accident/get-paged`, payload);
  }
}
